const languages = [
  { key: "af_ZA", value: "Afrikaans" },
  { key: "sq_AL", value: "Albanian" },
  { key: "ar_AR", value: "Arabic" },
  { key: "hy_AM", value: "Armenian" },
  { key: "az_AZ", value: "Azerbaijani" },
  { key: "eu_ES", value: "Basque" },
  { key: "be_BY", value: "Belarusian" },
  { key: "bn_IN", value: "Bengali" },
  { key: "bs_BA", value: "Bosnian" },
  { key: "bg_BG", value: "Bulgarian" },
  { key: "my_MM", value: "Burmese - MYANMAR" },
  { key: "ca_ES", value: "Catalan" },
  { key: "zh_CN", value: "Chinese (China)" },
  { key: "zh_HK", value: "Chinese (Hong Kong)" },
  { key: "zh_TW", value: "Chinese (Taiwan)" },
  { key: "hr_HR", value: "Croatian" },
  { key: "cs_CZ", value: "Czech" },
  { key: "da_DK", value: "Danish" },
  { key: "default", value: "Default" },
  { key: "nl_NL", value: "Dutch" },
  { key: "en_PI", value: "English (Pirate)" },
  { key: "en_GB", value: "English (UK)" },
  { key: "en_US", value: "English (US)" },
  { key: "en_UD", value: "English (Upside Down)" },
  { key: "eo_EO", value: "Esperanto" },
  { key: "et_EE", value: "Estonian" },
  { key: "fo_FO", value: "Faroese" },
  { key: "tl_PH", value: "Filipino" },
  { key: "fi_FI", value: "Finnish" },
  { key: "fr_CA", value: "French (Canada)" },
  { key: "fr_FR", value: "French (France)" },
  { key: "fy_NL", value: "Frisian" },
  { key: "gl_ES", value: "Galician" },
  { key: "ka_GE", value: "Georgian" },
  { key: "de_DE", value: "German" },
  { key: "el_GR", value: "Greek" },
  { key: "he_IL", value: "Hebrew" },
  { key: "hi_IN", value: "Hindi" },
  { key: "hu_HU", value: "Hungarian" },
  { key: "is_IS", value: "Icelandic" },
  { key: "id_ID", value: "Indonesian" },
  { key: "ga_IE", value: "Irish" },
  { key: "it_IT", value: "Italian" },
  { key: "ja_JP", value: "Japanese" },
  { key: "km_KH", value: "Khmer" },
  { key: "ko_KR", value: "Korean" },
  { key: "ku_TR", value: "Kurdish" },
  { key: "la_VA", value: "Latin" },
  { key: "lv_LV", value: "Latvian" },
  { key: "fb_LT", value: "Leet Speak" },
  { key: "lt_LT", value: "Lithuanian" },
  { key: "mk_MK", value: "Macedonian" },
  { key: "ms_MY", value: "Malay" },
  { key: "ml_IN", value: "Malayalam" },
  { key: "ne_NP", value: "Nepali" },
  { key: "nb_NO", value: "Norwegian (bokmal)" },
  { key: "nn_NO", value: "Norwegian (nynorsk)" },
  { key: "ps_AF", value: "Pashto" },
  { key: "fa_IR", value: "Persian" },
  { key: "pl_PL", value: "Polish" },
  { key: "pt_BR", value: "Portuguese (Brazil)" },
  { key: "pt_PT", value: "Portuguese (Portugal)" },
  { key: "pa_IN", value: "Punjabi" },
  { key: "ro_RO", value: "Romanian" },
  { key: "ru_RU", value: "Russian" },
  { key: "sr_RS", value: "Serbian" },
  { key: "sk_SK", value: "Slovak" },
  { key: "sl_SI", value: "Slovenian" },
  { key: "es_LA", value: "Spanish" },
  { key: "es_ES", value: "Spanish (Spain)" },
  { key: "sw_KE", value: "Swahili" },
  { key: "sv_SE", value: "Swedish" },
  { key: "ta_IN", value: "Tamil" },
  { key: "te_IN", value: "Telugu" },
  { key: "th_TH", value: "Thai" },
  { key: "tr_TR", value: "Turkish" },
  { key: "uk_UA", value: "Ukrainian" },
  { key: "vi_VN", value: "Vietnamese" },
  { key: "cy_GB", value: "Welsh" },
]

export {
  languages,
}